import { render, staticRenderFns } from "./PreferencesAgePage.vue?vue&type=template&id=a6678dc8"
import script from "./PreferencesAgePage.vue?vue&type=script&lang=js"
export * from "./PreferencesAgePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports